import { Card, CardBody, CardSubtitle } from 'reactstrap';
import PropTypes from 'prop-types';
import Text from './common/Text';

const ComponentCard = ({ children, title, subtitle }) => {
  return (
    <Card>
      {title && (
        <Text
          variant="cardTitle"
          className="border-bottom px-4 py-3 mb-0"
        >
          {title}
        </Text>
      )}

      <CardBody className="p-3">
        <CardSubtitle className="text-muted">
          {subtitle || ''}
        </CardSubtitle>

        <div>{children}</div>
      </CardBody>
    </Card>
  );
};

ComponentCard.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  subtitle: PropTypes.node,
};

export default ComponentCard;